<template>
    <div class="dropdown dropup">
        <button class="btn btn-secondary dropdown-toggle"
                id="dropdownMenuButton"
                @click.stop="showDropdown = !showDropdown"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                :aria-expanded="showDropdown">
            <img :src="activeLocaleImageSrc" alt="active language">
        </button>

        <div class="dropdown-menu" :class="{ show: showDropdown }" aria-labelledby="dropdownMenuButton">
            <button v-for="l in locales" :key="l.isoCode"
                    type="button"
                    @click="locale = l.isoCode"
                    class="dropdown-item" :class="{ active: lang === l.lang }">
                <img :src="l.iconSrc" :alt="l.isoCode" />

                {{ $t(l.translationKey) }}
            </button>
        </div>
    </div>

</template>

<script>
import locales from '@/models/locales';
import { mapGetters } from 'vuex';

export default {
    name: 'LanguageSelect',
    components: {},
    data () {
        return {
            showDropdown: false,
            locales
        }
    },
    props: {},
    computed: {
        ...mapGetters(['lang']),
        activeLocaleImageSrc() {
            let activeLocale = Object.values(this.locales).find(locale => locale.lang === this.lang);
            return activeLocale ? activeLocale.iconSrc : null;
        },
        locale: {
            get() {
                return this.$store.state.locale;
            },
            set(locale) {
                this.$store.commit('setLocale', locale);
            }
        }
    },
    watch: {
        async showDropdown(value) {
            if (value) {
                await this.$nextTick();
                document.addEventListener('click', e => {
                    this.showDropdown = false;
                }, {
                    once: true
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
@use "@/styles/_variables";
@use "sass:map";

    .dropdown-toggle {
        padding: 0.3rem;
        border: none;
    }

    .dropdown-menu {
        left: 50%;
        transform: translateX(-50%);
    }

    .dropdown-item {
        padding: 3px 10px;

        &.active, &:active {
            background: map.get(variables.$colors, 'secondary');
        }
    }
</style>
